import { createBrowserHistory } from 'quartz-routing/react-router';
import { getRootUrl } from '../utils/getRootUrl';
const history = createBrowserHistory({
  basename: getRootUrl()
});
export function getHistory() {
  return history;
}